import clsx from "clsx";

import { Context } from "types/context/Context";

import textListStyles from "./TextList.module.css";
import { TextListType_textList } from "./queries/contentfulTypes/TextListType";

interface ITextListProps {
  blockData: TextListType_textList;
  context?: Context;
  className?: string;
}

export const TextList = ({ blockData: textListData, className }: ITextListProps) => {
  const textListStyle = clsx(textListStyles.list, className, {
    ["green-usp"]: textListData.listStyle.includes("Gröna uspar"),
  });

  const listItems = textListData.texts.map((item, index) => {
    return <li key={index}>{item}</li>;
  });
  return (
    <ul
      className={textListStyle}
      data-contentful-entry-id={textListData.sys.id}
      data-contentful-field-id="name"
    >
      {listItems}
    </ul>
  );
};
